export abstract class BaseModel {
    constructor(public updated: Date) { }
}